import { nextTick } from 'process'
export default function fixedTableCol() {
  nextTick(() => {
    const tables = document.querySelectorAll('.table-unrealized-wrap');
    let isInTable = false;

    function fixedTableCol() {
      tables.forEach((table) => {
        const bg = table.querySelector('.table-unrealized__bottom-bg');
        const tableHead = table.querySelector('.table__head');
        const cell = table.querySelectorAll('[data-fixed]');

        const { bottom: tableHeadBottom } = tableHead.getBoundingClientRect();
        const { bottom: tableBottom, left: tableLeft } = table.getBoundingClientRect();

        bg.style.top = `${tableBottom - 1}px`;
        bg.style.left = `${tableLeft}px`;
        bg.style.width = `${table.scrollWidth}px`;

        cell.forEach((el) => {
          el.classList.add('fixed');
          const child = el.firstElementChild;
          const { height, top, bottom } = el.getBoundingClientRect();
          const width = el.scrollWidth;
          child.style.width = `${width}px`;
          child.style.height = `${height}px`;
          child.style.top = `${top}px`;
          child.style.left = `${tableLeft + 1}px`;
          if (bottom - height <= tableBottom && (top + height >= tableHeadBottom)) {
            el.firstElementChild.style.opacity = '1';
          } else {
            if (!el.closest('.table__head')) {
              el.firstElementChild.style.opacity = '0';
            }
          }
        });
      });
    }

    function resetTableToInitialState() {
      tables.forEach((table) => {
        const bg = table.querySelector('.table-unrealized__bottom-bg');
        bg.style.top = '';
        bg.style.left = '';
        bg.style.width = '';

        const cells = table.querySelectorAll('[data-fixed]');
        cells.forEach((cell) => {
          // 設定の削除
          cell.classList.remove('fixed');
          const child = cell.firstElementChild;
          child.style.width = '';
          child.style.height = '';
          child.style.top = '';
          child.style.left = '';
          child.style.opacity = '';
        });

        table.scrollTop = 0;
        table.scrollLeft = 0;
      });
    }

    tables.forEach((table) => {
      if (table.scrollWidth <= 580) {

        const simpleBar = document.querySelectorAll('[data-simplebar]');

        simpleBar.forEach((bar) => {
          const scrollableEl = bar.querySelector('.simplebar-content-wrapper');
          scrollableEl.addEventListener('scroll', () => {
            isInTable = true;
            fixedTableCol();
          });
          scrollableEl.addEventListener('touchstart', () => {
            if (!isInTable) {
              isInTable = true;
              fixedTableCol();
            }
          });
          scrollableEl.addEventListener('blur', () => {
            if (isInTable) {
              isInTable = false;
              resetTableToInitialState();
            }
          });
        });

        document.addEventListener('scroll', (event) => {
          if (event.target === document && isInTable) {
            isInTable = false;
            resetTableToInitialState();
          }
        });
      }
    });

    const normalizeHeightTableTd = () => {
      const tablesEl = document.querySelectorAll('.table.table--procedures');
      if (!tablesEl.length) return;
      tablesEl.forEach((el) => {
        const tableTrs = el.querySelectorAll('.table__tr');

        const getMaxHeight = (tableItem) => {
          const max = [];
          if (tableItem.childElementCount >= 2) {
            const td = tableItem.querySelectorAll('.table__td');
            td.forEach((t) => max.push(t.scrollHeight));
          }
          return Math.max(...max);
        };

        tableTrs.forEach((tr) => {
          const tableTrItems = tr.querySelectorAll('.table__tr-item');
          tableTrItems.forEach((item) => {
            const td = item.querySelectorAll('.table__td');
            if (item.childElementCount >= 2) {
              td.forEach((t) => (t.style.minHeight = `${getMaxHeight(item)}px`));
            }
          });
        });
      });
    };

    normalizeHeightTableTd();
  })
}
export function normalizeHeightTable() {
  const tablesEl = document.querySelectorAll('.table--designation .table__body .simple-content .table__tr');
  if (!tablesEl.length) return;
  
  const handler = ()=> {
    let height = 0
    tablesEl.forEach((tr) => {
      height += tr.scrollHeight + 1
    });

    if (height <= 210) {
      document.querySelector('.table--designation .table__body').style.minHeight = `${height + 1}px`
    }
  }
  handler()
  window.addEventListener('resize', handler);  
}
